import MojitoServices from 'mojito/services';
import MojitoPresentation from 'mojito/presentation';
const { useLocalizedParams } = MojitoPresentation.Hooks;
import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import RaceMeetingPageView from './race-meeting-page-view/index.js';

const { makeSelectMeetingsByIds } = MojitoServices.SportsContent.Meetings.selectors;

export default function RaceMeetingPage() {
    const { sportId, meetingId, raceId } = useLocalizedParams();

    const selectMeetingsByIds = useMemo(makeSelectMeetingsByIds, []);
    const meetings = useSelector(state => selectMeetingsByIds([meetingId], state));

    return (
        <div className="ta-RaceMeetingPage">
            <RaceMeetingPageView
                sportId={sportId}
                meetingId={meetingId}
                raceId={raceId}
                meetings={meetings}
            />
        </div>
    );
}
